export const menuItems = [
  { name: "", label: "Home" },
  { name: "about", label: "About" },
  { name: "solutions", label: "Solutions" },
  { name: "partners", label: "Partners" },
  { name: "studies", label: "Case Studies" },
  { name: "blog", label: "Blog" },
  { name: "contact", label: "Contact" },
];
